// @flow
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import i18n from 'i18n-js';

import { MdClose } from 'react-icons/lib/md';
import * as closeableActions from '../../../actions/closeable';
import PopupContainer from '../../PopupContainer';
import PopupHeader from '../../PopupHeader';
import PopupHeaderLeftGroup from '../../PopupHeaderLeftGroup';
import PopupHeaderRightGroup from '../../PopupHeaderRightGroup';
import PopupCloseButton from '../../PopupCloseButton';
import PopupHeaderTitle from '../../PopupHeaderTitle';
import PopupContent from '../../PopupContent';
import PopupFooter from '../../PopupFooter';
import { RenderTextarea } from '../../FieldRenderer/index';
import Button from '../../Button';

import styles from './changeStopPopover.css';

type ChangeStopPopoverTypes = {
  onUpdate: Function,
  handleSubmit: Function,
};

const ChangeStopPopover = ({
  onUpdate,
  handleSubmit,
}: ChangeStopPopoverTypes) => (
  <PopupContainer size="small">
    <PopupHeader>
      <PopupHeaderLeftGroup>
        <PopupHeaderTitle
          title={i18n.t('changeStopRequests.reason')}
          size="big"
        />
      </PopupHeaderLeftGroup>
      <PopupHeaderRightGroup>
        <PopupCloseButton
          size="medium"
          Icon={MdClose}
          tint="mediumGray"
          clearMargins
          isTransparent
          isOutlined
        />
      </PopupHeaderRightGroup>
    </PopupHeader>
    <form onSubmit={handleSubmit} className={styles.form}>
      <PopupContent className={styles.content} isBorderless>
        <Field
          name="description"
          component={RenderTextarea}
        />
      </PopupContent>
      <PopupFooter>
        <Button type="submit" size="medium" title={i18n.t('buttons.send')} />
      </PopupFooter>
    </form>
  </PopupContainer>
);


export default reduxForm({
  form: 'sendChangeStop',
  onSubmit({ description }, dispatch, { onUpdate, id }) {
    onUpdate(description);
    dispatch(closeableActions.close(id));
  },
})(ChangeStopPopover);



// WEBPACK FOOTER //
// ./src/scripts/components/ChangeStopRequestCard/ChangeStopPopover/index.jsx